import { Card } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";

export const ExamActionCardSkeleton = () => {
	const { isMobile } = useDevice();
	const theme = useAppTheme();
	return (
		<FlatCard style={{ borderRadius: theme.roundness * 1 }}>
			<Card.Content
				style={{
					flexDirection: isMobile ? "column" : "row",
					alignItems: isMobile ? "flex-start" : "center",
					justifyContent: "space-between",
					gap: 16,
					width: "100%",
					padding: 16,
				}}
			>
				<Box flex={1} gap={8} width="100%" minWidth={0} alignSelf="stretch">
					<Box flexDirection="row" gap={8}>
						<Skeleton width={88} height={28} borderRadius={theme.roundness} />
						<Skeleton width={80} height={28} borderRadius={theme.roundness} />
						<Skeleton width={72} height={28} borderRadius={theme.roundness} />
					</Box>
					<Skeleton width="70%" height={24} />
					<Skeleton width="90%" height={16} />
				</Box>
				<Box
					width={isMobile ? "100%" : "auto"}
					flexDirection="row"
					alignItems="center"
					justifyContent="flex-end"
					gap={16}
					borderTopWidth={isMobile ? 1 : 0}
					borderColor={theme.colors.surfaceVariant}
					paddingTop={isMobile ? 16 : 0}
				>
					<Skeleton
						width={140}
						height={40}
						borderRadius={theme.roundness * 5}
					/>
				</Box>
			</Card.Content>
		</FlatCard>
	);
};
